import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ICompleteRemoteRefreshAgentWorkflowParams {
  workflowId: string;
}

export class CompleteRemoteRefreshAgentWorkflowRequest
extends Request<ICompleteRemoteRefreshAgentWorkflowParams, IResult> {
  constructor(params: ICompleteRemoteRefreshAgentWorkflowParams) {
    super('completeRemoteRefreshAgentWorkflow', params);
  }
}
